module.exports = __webpack_public_path__ + "static/media/security-bg.f5fc4660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/security-bg.jpg
// module id = 5758
// module chunks = 6